import { atom } from "jotai";
import { RefObject } from "react";

// Atom to store actual ref of the CASI Chat Panel
// to be able to exclude it in useOutsideClick for the context chip
const CasiChatBookviewRefAtom = atom<RefObject<HTMLElement>>();

export default CasiChatBookviewRefAtom;
